import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, useCallback, useRef, useState } from "react";
import { stringify } from "qs";
import { useConfigurationEvent, useSessionId, } from "@plansoft-configuration-renderer/framework";
const IframeResizer = lazy(() => import("iframe-resizer-react"));
export function Viewer3DFrame(props) {
    const { width, height, autoResize = false, checkOrigin = false, debugResize = false, resetOnChange = false, } = props;
    const sessionId = useSessionId();
    const ref = useRef(null);
    const [counter, setCounter] = useState(0);
    const onConfigurationEvent = useCallback((event) => {
        var _a;
        if (resetOnChange) {
            setCounter((c) => c + 1);
        }
        else {
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.sendMessage(event);
        }
    }, [resetOnChange]);
    const {} = useConfigurationEvent({
        onConfigurationEvent: onConfigurationEvent,
    });
    const viewerOptions = stringify({
        viewerOnly: true,
        sessionId: sessionId,
    });
    const isLocalDevelopment = window.location.hostname === "localhost";
    // This is a hack to get the iframe to work in local development. Final URL? Better solution?
    const iFrameUrl = isLocalDevelopment
        ? "http://localhost:3000"
        : "../config3d/";
    // in local development, the iframe url also needs to be false, else it will fail because of the different port
    const iframeCheckOrigin = isLocalDevelopment ? false : checkOrigin;
    const iFrameSrc = `${iFrameUrl}?${viewerOptions}`;
    return (_jsx(IframeResizer, { forwardRef: ref, src: iFrameSrc, checkOrigin: iframeCheckOrigin, autoResize: autoResize, width: width, height: height, log: debugResize, style: props.style }, counter));
}
//# sourceMappingURL=Viewer3DFrame.js.map